import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import { AccessManagementRole } from '@flowx/designer/modules/core/dictionary/access-management.dictionary'
import { ApiHttpService } from '@flowx/designer/shared/api/api-http.service'

@Injectable({
  providedIn: 'root',
})
export class RoleApiService extends ApiHttpService {
  #url = 'auth/api/iam/roles'
  constructor() {
    const baseUrl = inject<string>('BASE_URL' as any)
    const httpClient = inject(HttpClient)

    super(baseUrl, httpClient)
  }

  getRolesNames(): Observable<string[]> {
    return this.get(`${this.#url}/names`)
  }

  getRoles(): Observable<(AccessManagementRole & { id: string })[]> {
    return this.get(this.#url)
  }

  createRole(role: AccessManagementRole): Observable<AccessManagementRole & { id: string }> {
    return this.post(this.#url, role)
  }

  updateRole(
    role: AccessManagementRole & { id: string }
  ): Observable<AccessManagementRole & { id: string }> {
    return this.put(this.#url, role)
  }

  deleteRole(id: string): Observable<void> {
    return this.delete(`${this.#url}/${id}`)
  }
}
